var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5C10.4477 5 10 5.44772 10 6V10H6C5.44771 10 5 10.4477 5 11V13C5 13.5523 5.44772 14 6 14H10V18C10 18.5523 10.4477 19 11 19H13C13.5523 19 14 18.5523 14 18V14H18C18.5523 14 19 13.5523 19 13V11C19 10.4477 18.5523 10 18 10H14V6C14 5.44772 13.5523 5 13 5H11ZM8 6C8 4.34315 9.34315 3 11 3H13C14.6569 3 16 4.34315 16 6V8H18C19.6569 8 21 9.34315 21 11V13C21 14.6569 19.6569 16 18 16H16V18C16 19.6569 14.6569 21 13 21H11C9.34315 21 8 19.6569 8 18V16H6C4.34315 16 3 14.6569 3 13V11C3 9.34314 4.34315 8 6 8H8V6Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCross);
export default __webpack_public_path__ + "static/media/medical-cross.484874cc33f403d8d7cde2a180e0eb07.svg";
export { ForwardRef as ReactComponent };